<!-- <app-loader *ngIf="isLoading()" /> -->
<div class="dialog-container">
  <div class="dialog-header">
    <h6>{{ isEditMode ? "Edit Vessel" : "Add Vessel" }}</h6>
    <button mat-icon-button class="close-icon" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <form [formGroup]="vesselForm" (ngSubmit)="onSubmit()">
    <div class="form-container">

      <mat-form-field appearance="outline" class="compact-form-field" floatLabel="always">
        <mat-label>Vessel Name</mat-label>
        <input matInput type="text" placeholder="Enter Vessel Name" formControlName="name"
          (keypress)="allowLimitedInput($event, 50)" (blur)="onInputTrim('name');"
          (paste)="onPaste($event)" />
        <mat-error *ngIf="vesselForm.get('name')?.hasError('required')">Vessel Name is required.</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="compact-form-field">
        <mat-label>IMO Number</mat-label>
        <input matInput type="number" placeholder="Enter IMO Number" formControlName="imo_number"
          (keypress)="allowLimitedInput($event, 7)" />
        <mat-error *ngIf="vesselForm.get('imo_number')?.hasError('required')">IMO number is required</mat-error>
        <mat-error *ngIf="vesselForm.get('imo_number')?.hasError('pattern')">Enter 7 digit IMO number</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="compact-form-field">
        <mat-label>GRT</mat-label>
        <input matInput type="number" placeholder="Enter GRT Value" formControlName="grt" />
        <mat-error *ngIf="vesselForm.get('grt')?.hasError('required')">GRT is required.</mat-error>
        <mat-error *ngIf="vesselForm.get('grt')?.hasError('negativeNumber')">Negative numbers are not
          allowed</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="compact-form-field">
        <mat-label>RGRT</mat-label>
        <input matInput type="number" placeholder="Enter RGRT Value" formControlName="rgrt" />
        <mat-error *ngIf="vesselForm.get('rgrt')?.hasError('negativeNumber')">Negative numbers are not
          allowed</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="compact-form-field">
        <mat-label>NRT</mat-label>
        <input matInput type="number" placeholder="Enter NRT Value" formControlName="nrt" />
        <mat-error *ngIf="vesselForm.get('nrt')?.hasError('required')">NRT is required.</mat-error>
        <mat-error *ngIf="vesselForm.get('nrt')?.hasError('negativeNumber')">Negative numbers are not
          allowed</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="compact-form-field">
        <mat-label>LOA</mat-label>
        <input matInput type="number" placeholder="Enter LOA Value" formControlName="loa" />
        <mat-error *ngIf="vesselForm.get('loa')?.hasError('required')">LOA is required.</mat-error>
        <mat-error *ngIf="vesselForm.get('loa')?.hasError('negativeNumber')">Negative numbers are not
          allowed</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="compact-form-field">
        <mat-label>Beam (in meters)</mat-label>
        <input matInput type="number" placeholder="Enter Beam Value" formControlName="beam" />
        <mat-error *ngIf="vesselForm.get('beam')?.hasError('required')">Beam is required.</mat-error>
        <mat-error *ngIf="vesselForm.get('beam')?.hasError('negativeNumber')">Negative numbers are not
          allowed</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="compact-form-field">
        <mat-label>Depth (in meters)</mat-label>
        <input matInput type="number" placeholder="Enter Depth Value" formControlName="depth" />
        <mat-error *ngIf="vesselForm.get('depth')?.hasError('required')">Depth is required.</mat-error>
        <mat-error *ngIf="vesselForm.get('depth')?.hasError('negativeNumber')">Negative numbers are not
          allowed</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="compact-form-field">
        <mat-label>Type Of Vessel</mat-label>
        <input matInput type="text" placeholder="Enter Vessel Type" formControlName="type"
          (keypress)="disallowNumericData($event);allowLimitedInput($event, 50)" (blur)="onInputTrim('type');"
          (paste)="onPaste($event)" />
        <mat-error *ngIf="vesselForm.get('type')?.hasError('required')">Type of Vessel is required.</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="compact-form-field">
        <mat-label>Dead Weight</mat-label>
        <input matInput type="number" placeholder="Enter Dead Weight" formControlName="dwt" />
        <mat-error *ngIf="vesselForm.get('dwt')?.hasError('required')">Dead Weight is required.</mat-error>
        <mat-error *ngIf="vesselForm.get('dwt')?.hasError('negativeNumber')">Negative numbers are not
          allowed</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="compact-form-field">
        <mat-label>Email</mat-label>
        <input matInput type="email" placeholder="Enter an Email" formControlName="email"
          (keypress)="allowLimitedInput($event, 50)" />
        <mat-error *ngIf="vesselForm.get('email')?.hasError('pattern')">Enter valid email.</mat-error>
      </mat-form-field>
      <!-- <div *ngIf="isEditMode">
        <mat-label class="status-label">Status</mat-label>
        <div class="toggle-wrapper">
          <span class="options">Inactive</span>
          <mat-slide-toggle formControlName="status" color="primary" class="custom-toggle"></mat-slide-toggle>
          <span class="options">Active</span>
        </div>
      </div> -->
    </div>

    <div class="fixed-button-container">
      <button mat-raised-button class="add-country" color="primary" type="submit">
        {{ isEditMode ? "Update Vessel" : "Add Vessel" }}
      </button>
    </div>
  </form>
</div>
